import type { SYSAction, SYSTableDefIds } from "../../../../_ovlclient/src"
import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  await TableRefresh("SYSAudit")
}

const HookScreenNavigateIn = async (_, { state, actions }) => {
  await TableRefresh("SYSAudit")
}

export let SYSAudit = { hooks: { HookScreenNavigateIn, HookScreenRefresh } }
